<template>

    <v-dialog max-width="80%" v-model="computed_dialog">
        <app-card>
            <app-section-loader :status="form_loader"></app-section-loader>
            <h4>PHIẾU CHẤM CÔNG</h4>
            <div>
                <hr class="mt-0" />
                <v-stepper-items>
                    <div>
                        <app-section-loader :status="loader"></app-section-loader>
                        <v-form ref="form">
                            <h4>
                                <v-flex xs12>
                                    <v-btn :loading="loading.submit"
                                        :disabled="loading.submit || chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH"
                                        @click="addRepairTimesheet()" flat color="primary">
                                        Thêm Phiếu Chấm Công
                                        <v-icon right dark>add</v-icon>
                                    </v-btn>
                                </v-flex>
                            </h4>
                            <v-layout row wrap v-for="(repairTimesheetItem, index) in this
                                .repairTimesheetsState" :key="'repair-time-sheet-item-' + index">
                                <v-flex xs12 md12>
                                    <cham-cong-item-trong-phieu-sua-chua @setRepairTimesheetsState="
                                        (repairTimesheetItem, index) => {
                                            setRepairTimesheetsState(
                                                repairTimesheetItem,
                                                index
                                            );
                                        }
                                    " @removeRepairTimesheet="
                                        (repairTimesheetItemIndex) =>
                                            removeRepairTimesheet(repairTimesheetItemIndex)
                                    " :repairTimesheetItem="repairTimesheetItem" :index="index"
                                        :repairTimesheetsProp="repairTimesheetsProp"
                                        :totalRepairTimesheetIndex="index + 1"
                                        :chosen_repair_request="chosen_repair_request"
                                        :repairmen="repairmen" />
                                </v-flex>
                            </v-layout>

                        </v-form>
                        <v-card-actions class="mt-5 mb-3">
                            <v-spacer></v-spacer>
                            <v-btn outline :loading="loading.submit" :disabled="loading.submit" @click="goBack"
                                color="primary">
                                Trở về
                            </v-btn>
                            <v-btn v-if="true"
                                :disabled="loading.submit || form_loader || chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH"
                                :loading="loading.submit || form_loader" @click="submit" color="primary">
                                Lưu
                            </v-btn>
                        </v-card-actions>
                    </div>
                </v-stepper-items>
            </div>

        </app-card>
    </v-dialog>

</template>

<script>
import {
    list_building
} from "Constants/db-config";
import {
    parseCurrency, buildParamQuery
} from "Helpers";
import api from '../../api';
import { REPAIR_REQUEST_STATUS, REPAIR_TIMESHEET_STATUS } from "../../constants/db-config";
import ChamCongItemTrongPhieuSuaChua from "./ChamCongItemTrongPhieuSuaChua.vue";

const REPAIR_TIMESHEET_ITEM_INIT_FORM = {
    receipt_id: "",
    room_id: "",
    repairman_name: "",
    completion_date: "",
    completion_time: null,
    labor_cost: "",
    material_cost: "",
    material_purchased: "",
    total_payment: "",
    status: REPAIR_TIMESHEET_STATUS.CHUA_CHI_TIEN
};

export default {
    props: ["repairTimesheetsProp", "chosen_repair_request", "dialog"],
    name: "dialog-cham-cong-trong-phieu-sua-chua",
    components: {
        ChamCongItemTrongPhieuSuaChua
    },
    data() {
        return {
            list_building,
            alert: {
                show: false,
                text: "",
                type: "error",
            },
            loading: {
                submit: false,
            },
            loader: false,
            repairTimesheetsState: [],
            form_loader: false,
            computed_dialog: false,
            REPAIR_REQUEST_STATUS,
            parseCurrency,
            repairmen: []
        };
    },
    watch: {
        repairTimesheetsProp() {
            this.updateRepairTimesheetsState();
        },
        computed_dialog(nv) {
            if (!nv) {
                this.updateRepairTimesheetsState();
                this.$emit('changeDialogState', nv);
            }
        },
        dialog(nv) {
            this.computed_dialog = nv
        }
    },
    computed: {
        rooms() {
            return this.$store.state.app.rooms;
        },
    },
    mounted() {
        this.updateRepairTimesheetsState();
        this.getRepairmen();
    },
    methods: {
        clearInput: function () {
            this.$refs.form.reset();
        },
        updateRepairTimesheetsState() {
            const isRoomExistInBuilding = this.rooms.filter(room => room.building === this.chosen_repair_request.building).map(room => room.room_id).includes(this.chosen_repair_request.room_id)
            this.repairTimesheetsState = this.repairTimesheetsProp.map(repairTimesheetItem => {
                return {
                    ...repairTimesheetItem,
                    receipt_id: this.chosen_repair_request.receipt_id,
                    customRoomId: isRoomExistInBuilding ? "" : repairTimesheetItem.room_id,
                    room_id: isRoomExistInBuilding ? repairTimesheetItem.room_id : "Khác",
                    isEdit: true
                }
            });
        },
        addRepairTimesheet() {
            const isRoomExistInBuilding = this.rooms.filter(room => room.building === this.chosen_repair_request.building).map(room => room.room_id).includes(this.chosen_repair_request.room_id)
            this.repairTimesheetsState.push({
                ...REPAIR_TIMESHEET_ITEM_INIT_FORM,
                receipt_id: this.chosen_repair_request.receipt_id,
                customRoomId: isRoomExistInBuilding ? "" : this.chosen_repair_request.room_id,
                room_id: isRoomExistInBuilding ? this.chosen_repair_request.room_id : "Khác",
            });
        },
        removeRepairTimesheet: function (index) {
            this.repairTimesheetsState.splice(index, 1);
        },
        setRepairTimesheetsState: function (repairTimesheetItem, index) {
            this.repairTimesheetsState[index] = repairTimesheetItem;
        },
        goBack: function () {
            this.$emit("changeDialogState", false);
        },
        submit: async function () {
            if (this.chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH) { return };

            if (!this.$refs.form.validate()) {
                swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                return
            }

            const postData = {
                dataArray: this.repairTimesheetsState.map(item => {
                    const labor_cost = Math.round(parseCurrency(item.labor_cost, "vi-VN", 'VND') / 1000) * 1000;

                    const material_cost = Math.round(parseCurrency(item.material_cost, "vi-VN", 'VND') / 1000) * 1000;

                    const total_payment = labor_cost + material_cost;
                    return {
                        ...item,
                        room_id: item.room_id === "Khác" ? item.customRoomId : item.room_id,
                        labor_cost,
                        material_cost,
                        total_payment,
                    }
                }),
            }

            this.loading.submit = true
            const data = await api.createOrEditRepairTimesheets(postData);
            this.loading.submit = false
            if (data.status === 200) {
                this.computed_dialog = false
                swal.fire('Thành công', data.data.message, 'success')
                this.$emit('reloadChamCong');
                this.$emit('reloadTable');
                this.$emit('onDialogRepairTimesheetSubmitted');
                this.clearInput()
            } else {
                swal.fire('Lỗi', data.message, 'error')
            }

        },
        async getRepairmen() {
            const params = {};
            const query = buildParamQuery(params)
            const response = await api.getRepairmen(query);

            if (response.status === 200) {
                this.repairmen = response.data.map(item => {
                    item.daily_hours = Number(item.daily_hours);
                    item.daily_wage = Number(item.daily_wage);
                    return item;
                });
            }
        }
    },
};
</script>

<style scoped>
table {
    border-collapse: collapse;
    width: 80%;
    max-width: 800px;
}

th {
    padding: 8px;
    border-bottom: 1px solid #ddd;
}

td {
    padding: 6px;
}

.cell-fit {
    width: 1%;
    white-space: nowrap;
}

.border-top {
    padding-top: 9px;
    border-top: 1px solid #ddd;
}

.hightlight-row {
    background-color: #ddfbe6;
}
</style>
